import { SelectOption } from '@property.com.au/ui-kit';
import { isNotNullOrUndefinedValue } from './isNotNullOrUndefinedValue';
import { SelectOptionWithBadge } from '../types';
import { SEARCH_SEPARATOR } from './defaults';

type SelectOptionByValueInput = {
  value?: string;
  options: (SelectOption | SelectOptionWithBadge)[];
  separator?: string;
};

export const getSelectOptionByLabel = <T extends SelectOptionByValueInput>({
  value = '',
  options,
}: T): T['options'][0] | null => {
  const lowercaseLabel = value.toLowerCase();
  return options?.find((option) => option?.label.toLowerCase() === lowercaseLabel) ?? null;
};

export const getSelectOptionByString = <T extends SelectOptionByValueInput>({
  value = '',
  options,
}: T): T['options'][0] | null => {
  return options?.find((option) => option.value === value) ?? null;
};

export const getMultipleSelectOptionsByString = ({
  value = '',
  options,
  separator = SEARCH_SEPARATOR,
}: SelectOptionByValueInput): (SelectOption | SelectOptionWithBadge)[] => {
  return value
    .split(separator)
    .map((item) => getSelectOptionByString({ value: item, options }))
    .filter(isNotNullOrUndefinedValue);
};
